import React from 'react';

const DropdownContext = React.createContext(null);

export const DropdownProvider = DropdownContext.Provider;
export const DropdownConsumer = DropdownContext.Consumer;
export default DropdownContext;
